import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="dma-completed"
export default class extends Controller {
  alert(event) {
    event.preventDefault();
    event.stopPropagation();

    // If it's a checkbox revert change

    if (event.target.tagName === 'INPUT' && event.target.type === 'checkbox') {
      event.target.checked = !event.target.checked;
    }

    alert(this.alertText());
  }

  alertText() {
    return (
      'Permissions needed\n\n' +
      'This module has been finalised so no edits can be made as they would have an impact ' +
      'on the subsequent module. Please contact a GFP member for further details.'
    );
  }
}
